<template>
    <div class="wrap ">
        <div class="main">
            <el-row class="line40">
                <el-col :span="14">
                    <ul>
                        <li v-for="(item, index) in list" :key="index" :class="select === item.id ? 'col333' : 'colfff'" @click="gonext(item.url, item.id)">
                            <span :class="[ item.id == menuId ? 'colred' : 'colb9b9', ' titleHouer', ]">{{ item.name }}</span>
                        </li>
                    </ul>
                </el-col>
                <el-col :span="2" :offset="3" class="textright colb9b9">
                    <span class="loginBtn titleHouer" @click="login">登录/注册</span>
                </el-col>
                <el-col :span="2" :offset="1" class="textright colb9b9">
                    <span class="colred ">028-62128912</span>
                </el-col>
            </el-row>
        </div>
        <div class="warpsearch padtb20" v-if="routeName != 'entrust'">
            <el-row class="main">
                <el-col :span="4">
                    <div class="logosmall">
                        <img src="/static/img/logo@2x.png" alt />
                        
                        <!-- <img src="" alt=""> -->
                    </div>
                </el-col>
                <el-col :span="1" class="line40 titleHouer">
                    <span data-v-1c27cb8a=""><img src="https://static.shuhuakongjian.com/zt/yuanxing-pc/dist/img/25faeb9.svg" alt="" data-v-1c27cb8a="">成都</span>
                </el-col>
                <!-- <el-col :span="8" class="padl40" v-if="list[select].arr!=undefined"> -->
                <!-- <span class="colfff">1</span> -->
                <!-- <div
            v-for="(item,index) in list[select].arr"
            :key="index"
            @click="getactive(item)"
            :class="item==active?'colred disinline  font16 font600 line40 padlr10':'disinline  font16 font600 line40 padlr10 titleHouer'"
          
          >{{item}}</div> -->
                <!-- </el-col> -->
                <el-col :span="6" :offset="11">
                    <el-input placeholder="输入区域/商圈/楼盘名称" v-model="search" @input="searchList" clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>

                    <div class="search-content" v-if="isShowTip">
                        <div class="search-content-item" v-for="(item, index) in resultList" :key="index" @click="searchDetail(item)">
                            <el-row>
                                <el-col :span="5">
                                    <span class="typeName">{{ item.typeName }}</span>
                                </el-col>
                                <el-col :span="10">
                                    <span>{{ item.name }}</span>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" plain class="search" @click="searchFun">搜索</el-button>
                </el-col>
            </el-row>
        </div>
        <router-view :searchVal="searchVal" :searchId="searchId" :searchType="searchType" @getMenuId="showMenuId" @setSearch="updateSearch" v-model="search"></router-view>
        <footers></footers>
        <regionDialog :dialogVisible="logindialogVisible" @close="close"></regionDialog>
    </div>
</template>

<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?9e0c3bb7a21ac1390b0fe0760240a0b0";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
import footers from "@/components/footer";
import regionDialog from "../components/region";
export default {
    data() {
        return {
            select: 1,
            menuId: 1,
            name: "",
            search: "",
            isShowTip: false,
            searchVal: "",
            searchId: "",
            searchType: "",
            list: [
                { name: "首页", url: "index", id: "0" },

                // {
                //   name: "二手房",
                //   url: "/secondHandList",
                //   id: "2",
                //   arr: ["二手房", "小区"]
                // },
                { name: "写字楼租赁", url: "OfficebuildList", id: "1" },
                { name: "写字楼买卖", url: "OfficeBuildingListSale", id: "2" },
                { name: "楼盘", url: "OfficeBuildingListRealEstate", id: "3" },
                // { name: "新房", url: "newhouseList", id: "5" },
                // { name: "商铺", url: "/", id: "4" },
                // {
                //   name: "租房",
                //   url: "/RentingRoom",
                //   id: "5",
                //   arr: ["首页", "整租", "合租"]
                // },
                { name: "委托找房", url: "entrustzf", id: "6" },
                { name: "投放房源", url: "entrustcz", id: "7" },
                //{ name: "资讯", url: "/", id: "7" },
            ],
            active: "",
            logindialogVisible: false,
            deviceList: [], // 调用接口获取的全部数据
            resultList: [], // 真正展示的数据，也就是筛选后的数据

        };
    },
    components: {
        footers,
        regionDialog,
    },
    created() {
    },
    computed: {
        routeName() {
            // 在声明路由的时候，每个路由都有自己的名称，就是name
            // vue中获取当前路由name
            let routeName = this.$route.name;
            if (
                routeName == "entrustcz" ||
                routeName == "entrustcs" ||
                routeName == "entrustzf" ||
                routeName == "entrustmf"
            ) {
                return "entrust";
            }
            return this.$route.name;
        },
    },
    // created() {
    //   this.select = window.location.href.split("=")[1];
    //   console.log("url1", this.select);
    //   if(this.select>10){
    //     this.active =  this.list[this.select].arr != undefined ? this.list[this.select].arr[0] : "";
    //   }

    // },
    mounted() {
        // this.name = window.location.href.split("?")[1].split("=")[0];
        console.log(this.$route.params);
        // if (this.name === "type") {

        //   this.select = window.location.href.split("?")[1].split("=")[1];
        //   // this.$store.commit("setType", this.select);
        //     //  console.log("105", this.select );
        //   localStorage.setItem("typeid",this.select)
        //   this.active =
        //     this.list[this.select].arr != undefined
        //       ? this.list[this.select].arr[0]
        //       : "";
        // } else {

        //   this.select =  localStorage.getItem("typeid") ;
        //   this.active=localStorage.getItem("active") ;
        //   // this.active =
        //   //   this.list[this.select].arr != undefined
        //   //     ? this.list[this.select].arr[this.active]
        //   //     : "";
        //   //  console.log(123,this.select, this.active)
        // }
        // console.log("url2", this.select);
    },
    methods: {
        searchFun() {
            this.searchVal = this.search;
            console.log("search", this.searchVal);
        },
        searchDetail(val) {
            this.isShowTip = false;
            this.search = val.name;
            this.searchId = val.id;
            this.searchType = val.type;
        },
        // getactive(type) {

        //   let name=window.location.href.split('#')[1].split('?')[0];
        //    localStorage.setItem("active",type)
        //   if(name=='/builsDetail' || name=='/officemmdetail' || name=='/officeLeaseDetail'){
        //     this.$router.push({ path:'/OfficebuildList', query: { type: localStorage.getItem("typeid")} });
        //   }
        //   this.active = type;
        // },
        gonext(path, id) {
            console.log("id", path, id);
            this.select = id;
            //   if (this.select < 10) {
            //     this.active =
            //       this.list[this.select].arr != undefined
            //         ? this.list[this.select].arr[0]
            //         : "";
            //   }
            //    this.name = window.location.href.split("?")[1].split("=")[0];

            // if (this.name === "type") {
            //    localStorage.setItem("typeid",id)
            //   }
            //this.$router.push({ name: path, params: { type: id } });

            let routeUrl = this.$router.resolve({
                path: path,
                query: {
                    type: id,
                },
            });
            window.open(routeUrl.href, "_blank");
        },

        login() {
            this.logindialogVisible = true;
        },
        close(val) {
            this.logindialogVisible = val;
        },
        showMenuId(val) {
            this.menuId = val;
        },
        updateSearch(val) {
            this.search = val;
            this.searchVal = val;
        },
        // getUrlParam(name) {
        //   // 取得url中?后面的字符
        //   var query = window.location.href.substring(1);
        //   // 把参数按&拆分成数组
        //   var param_arr = query.split("&");
        //   for (var i = 0; i < param_arr.length; i++) {
        //     var pair = param_arr[i].split("=");
        //     if (pair[0] == name) {
        //       return pair[1];
        //     }
        //   }
        //   return false;
        // }
        searchList() {
            this.isShowTip = true;
            console.log("城市行政区");
            if (this.search === "") {
                this.isShowTip = false;
                return;
            }
            if (this.search && this.search.length > 0) {
                return new Promise((resolve, reject) => {
                    this.$get(this.$api.common.search, { search: this.search })
                        .then((res) => {
                            // console.log("城市行政区", res);
                            if (res.code == 0) {
                                this.resultList = res.data;
                            }
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            }
        },
    },
};
</script>

<style   lang="scss">
.wrap {
    width: 100%;
    height: 2.5rem;
    background: #333;
}
.warpsearch{
    width: 100%;
    height: 2.5rem;
    background: #f8f8f8; 
}
.main {
    width: 75rem;
    margin: auto;
    color: #666;
    font-size: 14px;
}
.warp {
    width: 100%;
    border-bottom: 0.0625rem solid #da251d;
    position: relative;
}
.logosmall {
    width: 9.25rem;
    height: 2.5rem;
}
.logosmall img {
    width: 100%;
    height: 100%;
}
.search {
    background: #da251d !important;
    border: 0px !important;
    color: #fff !important ;
}
ul li {
    float: left;
    margin-right: 2.25rem;
}
.search-content {
    width: 25%;
    cursor: pointer;
    z-index: 999;
    position: absolute;
    background: #fff;
    border-width: 1px;
    border-color: #eae0e0;
    border-style: solid;
}
.search-content-item {
    margin: 0.25rem;
}
.typeName {
    color: #ffb294;
    background-color: #ffe8dc;
    margin: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/home.vue